<template>
    <div id="wrapper">
        <Header/>
        <main class="main">
            <router-view/>
        </main>
        <Footer/>
    </div>
</template>

<style lang="scss">
</style>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
    components: { Footer, Header },
  mounted() {
      this.$store.dispatch('bootstrap');
  }
}
</script>
